import { useQuery } from '@tanstack/react-query'
import { getProjectOverview } from '../../entities/project/service'
import { PROJECT_OVERVIEW_QUERY_KEY } from './keys'

export { PROJECT_OVERVIEW_QUERY_KEY }

export const useProjectOverview = ({ client, projectId }) => {
  return useQuery({
    queryKey: [...PROJECT_OVERVIEW_QUERY_KEY, projectId],
    queryFn: () => getProjectOverview(client, projectId),
    enabled: !!client && !!projectId,
    staleTime: 15 * 60 * 1000,
  })
}
